import { render, staticRenderFns } from "./call-notice-dialog.vue?vue&type=template&id=04f5772c"
import script from "./call-notice-dialog.vue?vue&type=script&lang=js"
export * from "./call-notice-dialog.vue?vue&type=script&lang=js"
import style0 from "./call-notice-dialog.vue?vue&type=style&index=0&id=04f5772c&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports